"use client";

import { SiteTemplatePageSectionTypeYogaDefaultListItemSettingModel } from "@/Apis/ClinicApi";
import { YogaSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import HomeSeventeenYogaSectionGenerated, {
  HomeSeventeenYogaSectionGeneratedProps,
} from "../Sections/_generated/HomeSeventeenYogaSection.generated";
import { buildGeneratedSectionProps } from "./generated-section-renderer";

function getYogaItems(
  props: YogaSectionProps,
): SiteTemplatePageSectionTypeYogaDefaultListItemSettingModel[] {
  return props.lists.Default ?? [];
}

const GeneratedYogaSection: FC<YogaSectionProps> = (props) => {
  const defaults =
    buildGeneratedSectionProps<HomeSeventeenYogaSectionGeneratedProps>(
      "HomeSeventeenYogaSection",
    );
  const items = getYogaItems(props);

  const item0 = items[0];
  const item1 = items[1];
  const item2 = items[2];
  const item3 = items[3];

  return (
    <HomeSeventeenYogaSectionGenerated
      {...defaults}
      sectionDiv0Div0ImageWithBasePath0ImageSrc={
        props.setting.Image?.Url ??
        defaults.sectionDiv0Div0ImageWithBasePath0ImageSrc
      }
      sectionDiv0Div0ImageWithBasePath0ImageAlt={
        props.setting.Image?.AltText ??
        defaults.sectionDiv0Div0ImageWithBasePath0ImageAlt
      }
      sectionDiv0Div0Div0H20H2Text={
        item0?.Title ?? defaults.sectionDiv0Div0Div0H20H2Text
      }
      sectionDiv0Div0Div0H20Span0SpanText={
        item0?.Subtitle ?? defaults.sectionDiv0Div0Div0H20Span0SpanText
      }
      sectionDiv0Div0Div0ImageWithBasePath0ImageSrc={
        item0?.Image?.Url ??
        defaults.sectionDiv0Div0Div0ImageWithBasePath0ImageSrc
      }
      sectionDiv0Div0Div0ImageWithBasePath0ImageAlt={
        item0?.Image?.AltText ??
        item0?.Title ??
        defaults.sectionDiv0Div0Div0ImageWithBasePath0ImageAlt
      }
      sectionDiv0Div0Div1H20H2Text={
        item1?.Title ?? defaults.sectionDiv0Div0Div1H20H2Text
      }
      sectionDiv0Div0Div1H20Span0SpanText={
        item1?.Subtitle ?? defaults.sectionDiv0Div0Div1H20Span0SpanText
      }
      sectionDiv0Div0Div1ImageWithBasePath0ImageSrc={
        item1?.Image?.Url ??
        defaults.sectionDiv0Div0Div1ImageWithBasePath0ImageSrc
      }
      sectionDiv0Div0Div1ImageWithBasePath0ImageAlt={
        item1?.Image?.AltText ??
        item1?.Title ??
        defaults.sectionDiv0Div0Div1ImageWithBasePath0ImageAlt
      }
      sectionDiv0Div0Div2H20H2Text={
        item2?.Title ?? defaults.sectionDiv0Div0Div2H20H2Text
      }
      sectionDiv0Div0Div2H20Span0SpanText={
        item2?.Subtitle ?? defaults.sectionDiv0Div0Div2H20Span0SpanText
      }
      sectionDiv0Div0Div2ImageWithBasePath0ImageSrc={
        item2?.Image?.Url ??
        defaults.sectionDiv0Div0Div2ImageWithBasePath0ImageSrc
      }
      sectionDiv0Div0Div2ImageWithBasePath0ImageAlt={
        item2?.Image?.AltText ??
        item2?.Title ??
        defaults.sectionDiv0Div0Div2ImageWithBasePath0ImageAlt
      }
      sectionDiv0Div0Div3H20H2Text={
        item3?.Title ?? defaults.sectionDiv0Div0Div3H20H2Text
      }
      sectionDiv0Div0Div3H20Span0SpanText={
        item3?.Subtitle ?? defaults.sectionDiv0Div0Div3H20Span0SpanText
      }
      sectionDiv0Div0Div3ImageWithBasePath0ImageSrc={
        item3?.Image?.Url ??
        defaults.sectionDiv0Div0Div3ImageWithBasePath0ImageSrc
      }
      sectionDiv0Div0Div3ImageWithBasePath0ImageAlt={
        item3?.Image?.AltText ??
        item3?.Title ??
        defaults.sectionDiv0Div0Div3ImageWithBasePath0ImageAlt
      }
    />
  );
};

export default GeneratedYogaSection;
